import { useEffect, useRef } from 'react';
import { FollowUpQuestions } from './FollowUpQuestions/FollowUpQuestions';
import { YoutubeTranscriptModal } from '../../components/modals/YoutubeTranscriptModal';
import { LoadingScreen } from './components/LoadingScreen';
import { useUnlimitedContext } from './contexts/UnlimitedContext';

/**
 * Renders the follow-up question flow when the user has submitted a prompt
 * and is answering clarifying questions before resource creation.
 */
export const UnlimitedFollowUpView = () => {
  const { input, followUp, attachments } = useUnlimitedContext();
  const prevShowFollowUp = useRef(followUp.showFollowUp);

  useEffect(() => {
    if (prevShowFollowUp.current && !followUp.showFollowUp) {
      const id = setTimeout(() => {
        input.adjustTextareaHeight();
        input.inputRef.current?.focus();
      }, 0);
      return () => clearTimeout(id);
    }
    prevShowFollowUp.current = followUp.showFollowUp;
  }, [followUp.showFollowUp, input.adjustTextareaHeight, input.inputRef]);

  return (
    <>
      {input.isCreating && <LoadingScreen text='Generating' />}
      <FollowUpQuestions
        key={followUp.questionKey}
        question={followUp.currentQuestion}
        questionNumber={followUp.previousQA.length + 1}
        isLoading={followUp.isLoadingNextQuestion}
        initialSelectedOptions={followUp.restoredSelections?.selectedOptions}
        initialOtherText={followUp.restoredSelections?.otherText}
        onAnswered={followUp.handleFollowUpAnswered}
        onBookConfirmed={followUp.handleBookConfirmed}
        onSourceContentProvided={followUp.handleSourceContentProvided}
        onYoutubeUrlDetected={(url, onTranscript) => {
          attachments.setYoutubeModalUrl(url);
          attachments.setShowYoutubeTranscriptModal(true);
          attachments.youtubeSourceContentCallback.current = onTranscript;
        }}
        onBack={followUp.handleFollowUpBack}
        onSkip={followUp.handleFollowUpSkip}
      />
      <YoutubeTranscriptModal
        showModal={attachments.showYoutubeTranscriptModal}
        setShowModal={attachments.handleYoutubeModalClose}
        youtubeUrl={attachments.youtubeModalUrl}
        onUseTranscript={attachments.handleYoutubeTranscript}
      />
    </>
  );
};
